// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inicio {
  border: none;
  font-weight: 900;
}

label {
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/select/cambio-perfil/cambio-perfil.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ","sourcesContent":[".inicio {\n    border: none;\n    font-weight: 900;\n}\nlabel {\n    font-weight: 900;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
